import { t } from '@i18n';
import type { PartialTableTheme } from 'schummar-table';

export default {
  text: {
    selectColumns: t('table.selectColumns'),
    showAllColumns: t('table.showAllColumns'),
    hideAllColumns: t('table.hideAllColumns'),
    noResults: t('table.noResults'),
    exportTitle: t('table.exportTitle'),
    exportCopy: t('table.exportCopy'),
    exportDownload: t('table.exportDownload'),
    today: t('table.today'),
    thisWeek: t('table.thisWeek'),
    thisMonth: t('table.thisMonth'),
    thisYear: t('table.thisYear'),
    lastSevenDays: t('table.lastSevenDays'),
    lastThirtyDays: t('table.lastThirtyDays'),
    reset: t('table.reset'),
    loading: t('table.loading'),
    clearFilters: t('table.clearFilters'),
    deselectAll: t('table.deselectAll'),
    resetAll: t('table.resetAll'),
    rangeMin: t('table.rangeMin'),
    rangeMax: t('table.rangeMax'),
    calendarWeek: t('table.calendarWeek'),
  },
} satisfies PartialTableTheme;
